import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  verifyAction,
  connectToWalletAction,
  disconnectWalletAction,
  updateProfileAction,
  setUsernameAction,
} from '../store/apps/auth';

export const useAuth = () => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.auth);
  const verifyAccessToken = useCallback(async () => {
    return dispatch(verifyAction());
  }, [dispatch]);
  const connectToWallet = useCallback(
    async (data) => {
      return dispatch(connectToWalletAction(data));
    },
    [dispatch],
  );
  const disconnectWallet = useCallback(async () => {
    return dispatch(disconnectWalletAction({}));
  }, [dispatch]);
  const UpdateProfile = useCallback(
    async (body) => {
      return dispatch(updateProfileAction(body));
    },
    [dispatch],
  );
  const SetUsername = useCallback(
    async (body) => {
      return dispatch(setUsernameAction(body));
    },
    [dispatch],
  );
  return {
    store,
    verifyAccessToken,
    connectToWallet,
    disconnectWallet,
    UpdateProfile,
    SetUsername,
  };
};
